import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/checkcircle.svg'


const _hoisted_1 = { class: "layout-eoi" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = {
  key: 0,
  class: "description"
}
const _hoisted_5 = {
  key: 1,
  class: "description"
}
const _hoisted_6 = { class: "back-dashboard" }
const _hoisted_7 = {
  key: 2,
  class: "back-map"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["HeaderCustomer"], {
      estate: $setup.estate,
      hideAuthButtons: true,
      isEmbedded: $setup.isEmbedded
    }, null, 8, ["estate", "isEmbedded"]),
    _createElementVNode("div", _hoisted_2, [
      (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo-box" }, [
              _createElementVNode("img", { src: _imports_0 })
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "headline" }, "You’ve joined the Waitlist", -1)),
            ($setup.isLogged())
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "You can view and edit your waitlist preferences at anytime by visiting the Waitlists section of your LotTrackr dashboard."))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", null, [
                    _createTextVNode("We’ll keep you informed about future releases at "),
                    _createElementVNode("br")
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.estate.title + "."), 1)
                ])),
            _createElementVNode("div", _hoisted_6, [
              ($setup.isLogged())
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    class: "button",
                    to: "/customer/waitlist"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("My Dashboard", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (!$setup.isEmbedded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("a", {
                    class: "back",
                    href: `/estate/${$setup.estateId}`
                  }, "Back to Map", 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9))
    ])
  ]))
}